<template>
  <nav class="app-nav" :class="{ 'nav-scrolled': scrolled, 'nav-open': mobileOpen }">
    <div class="nav-inner container">
      <router-link to="/" class="nav-brand" @click.native="mobileOpen = false">
        <img
          src="/logo.png"
          alt="ELTTEC 易伦特科技"
          class="nav-logo-img"
          height="36"
        />
      </router-link>

      <ul class="nav-links" :class="{ active: mobileOpen }">
        <li><a href="/#home" @click.prevent="scrollTo('home')">{{ $store.getters.t('nav.home') }}</a></li>
        <li class="nav-dropdown-wrapper" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <a href="/#products" @click.prevent="scrollTo('products')" class="nav-dropdown-trigger">
            {{ $store.getters.t('nav.products') }}
            <svg class="dropdown-arrow" width="12" height="12" viewBox="0 0 12 12"><path d="M3 5l3 3 3-3" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>
          </a>
          <ul class="nav-dropdown" :class="{ show: showDropdown }">
            <li><a href="/#ssms" @click.prevent="scrollTo('ssms')">AI SSP</a></li>
            <li><a href="/#eom" @click.prevent="scrollTo('eom')">AI EOM</a></li>
            <li><a href="/#rpa" @click.prevent="scrollTo('rpa')">AI RPA</a></li>
            <li><a href="/#dauto" @click.prevent="scrollTo('dauto')">DAutomation</a></li>
            <li class="dropdown-divider"></li>
            <li><router-link to="/digital-automation">Digital Automation</router-link></li>
          </ul>
        </li>
        <li><a href="/#about" @click.prevent="scrollTo('about')">{{ $store.getters.t('nav.about') }}</a></li>
        <li>
          <a :href="$store.getters.t('hero.cta1Link')" target="_blank" class="nav-demo-btn">
            {{ $store.getters.t('nav.demo') }}
            <svg width="16" height="16" viewBox="0 0 16 16"><path d="M6 4l5 4-5 4" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>
          </a>
        </li>
        <li>
          <button class="lang-btn" @click="$store.dispatch('toggleLocale')" :title="$store.getters.isZh ? 'Switch to English' : '切换到中文'">
            <svg width="16" height="16" viewBox="0 0 16 16"><circle cx="8" cy="8" r="6.5" stroke="currentColor" fill="none" stroke-width="1.2"/><ellipse cx="8" cy="8" rx="3" ry="6.5" stroke="currentColor" fill="none" stroke-width="1.2"/><path d="M2 8h12" stroke="currentColor" stroke-width="1.2"/></svg>
            {{ $store.getters.isZh ? 'EN' : '中文' }}
          </button>
        </li>
      </ul>

      <button class="mobile-toggle" @click="mobileOpen = !mobileOpen" :aria-label="mobileOpen ? '关闭菜单' : '打开菜单'">
        <span></span><span></span><span></span>
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AppNav',
  data() {
    return { scrolled: false, mobileOpen: false, showDropdown: false }
  },
  methods: {
    scrollTo(sectionId) {
      if (this.$route.path !== '/') {
        this.$router.push('/').then(() => {
          this.$nextTick(() => {
            const el = document.getElementById(sectionId)
            if (el) el.scrollIntoView({ behavior: 'smooth' })
          })
        })
      } else {
        const el = document.getElementById(sectionId)
        if (el) el.scrollIntoView({ behavior: 'smooth' })
      }
      this.mobileOpen = false
      this.showDropdown = false
    },
    onScroll() {
      this.scrolled = window.scrollY > 50
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  watch: {
    '$route'() { this.mobileOpen = false; this.showDropdown = false }
  }
}
</script>

<style scoped>
.app-nav {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 1000;
  padding: 14px 0;
  transition: all 0.35s cubic-bezier(.4,0,.2,1);
}
.app-nav.nav-scrolled {
  background: rgba(10,15,28,.92);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border-bottom: 1px solid rgba(255,255,255,.06);
  padding: 8px 0;
  box-shadow: 0 1px 40px rgba(0,0,0,.25);
}
.nav-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nav-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: .03em;
  color: #f1f5f9;
  text-decoration: none;
}
.nav-logo-img {
  height: 36px;
  width: auto;
  display: block;
  filter: drop-shadow(0 0 12px rgba(59,130,246,.2));
  transition: filter .3s;
}
.nav-brand:hover .nav-logo-img {
  filter: drop-shadow(0 0 18px rgba(59,130,246,.35));
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 6px;
  list-style: none;
  margin: 0;
}
.nav-links > li > a {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14.5px;
  font-weight: 500;
  color: #94a3b8;
  padding: 8px 14px;
  border-radius: 8px;
  transition: all 0.25s;
  cursor: pointer;
  text-decoration: none;
}
.nav-links > li > a:hover,
.nav-links > li > a.router-link-exact-active,
.nav-links > li > a.router-link-active {
  color: #e2e8f0;
  background: rgba(255,255,255,.06);
}

/* Dropdown */
.nav-dropdown-wrapper { position: relative; }
.nav-dropdown-trigger { gap: 6px !important; }
.dropdown-arrow { opacity: .5; margin-top: 1px; }
.nav-dropdown-wrapper:hover .dropdown-arrow { opacity: 1; }
.nav-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%) translateY(6px);
  min-width: 210px;
  background: rgba(15,23,42,.98);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255,255,255,.08);
  border-radius: 12px;
  padding: 6px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.25s cubic-bezier(.4,0,.2,1);
  box-shadow: 0 12px 40px rgba(0,0,0,.4);
  list-style: none;
}
.nav-dropdown.show {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}
.nav-dropdown li a {
  display: block;
  padding: 10px 14px;
  font-size: 13.5px;
  color: #94a3b8;
  border-radius: 8px;
  transition: all 0.2s;
  white-space: nowrap;
  text-decoration: none;
}
.nav-dropdown li a:hover { color: #e2e8f0; background: rgba(255,255,255,.06); }
.dropdown-divider { height: 1px; background: rgba(255,255,255,.06); margin: 4px 0; }

/* Demo CTA Button */
.nav-demo-btn {
  background: linear-gradient(135deg, #3b82f6, #2563eb) !important;
  color: #fff !important;
  padding: 8px 18px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  transition: all 0.3s !important;
}
.nav-demo-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(59,130,246,.4);
}

/* Language Toggle */
.lang-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,.1);
  background: rgba(255,255,255,.04);
  color: #94a3b8;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.25s;
}
.lang-btn:hover { border-color: rgba(59,130,246,.5); color: #e2e8f0; }

/* Mobile Toggle */
.mobile-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  z-index: 1001;
}
.mobile-toggle span {
  display: block;
  width: 24px;
  height: 2px;
  background: #e2e8f0;
  border-radius: 2px;
  transition: all 0.3s;
}
.nav-open .mobile-toggle span:nth-child(1) { transform: rotate(45deg) translate(5px,5px); }
.nav-open .mobile-toggle span:nth-child(2) { opacity: 0; }
.nav-open .mobile-toggle span:nth-child(3) { transform: rotate(-45deg) translate(5px,-5px); }

@media (max-width: 768px) {
  .app-nav { background: rgba(10,15,28,.95); backdrop-filter: blur(12px); }
  .mobile-toggle { display: flex; }
  .nav-links {
    position: fixed;
    top: 60px; left: 0; right: 0; bottom: 0;
    background: rgba(10,15,28,.98);
    backdrop-filter: blur(16px);
    flex-direction: column;
    justify-content: flex-start;
    padding: 40px 24px;
    gap: 8px;
    transform: translateX(100%);
    transition: transform 0.4s cubic-bezier(.4,0,.2,1);
    overflow-y: auto;
  }
  .nav-links.active { transform: translateX(0); }
  .nav-links > li { width: 100%; }
  .nav-links > li > a { font-size: 17px; padding: 14px 16px; width: 100%; }
  .nav-dropdown {
    position: static;
    transform: none;
    opacity: 1;
    visibility: visible;
    background: rgba(255,255,255,.03);
    margin: 4px 8px 0;
    border-radius: 10px;
    box-shadow: none;
    display: block;
  }
  .nav-demo-btn { justify-content: center; margin-top: 12px; }
}
</style>
